import React from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";
import "./payslip-cards.css";

// Composant pour une carte de cotisation
const CotisationCard = ({ 
  Libelle, 
  Assiette, 
  TauxSalariale, 
  CotisationSalariale, 
  TauxPatronale, 
  CotisationPatronale, 
  icon = "💼",
  cardClass = ""
}) => {
  if (CotisationSalariale === 0 && CotisationPatronale === 0) {
    return null;
  }

  return (
    <div className={`payslip-card ${cardClass}`}>
      <div className="payslip-column libelle">
        <div className="payslip-icon">{icon}</div>
        {Libelle}
      </div>
      <div className="payslip-column assiette">
        {Assiette === "" ? "" : applyFormat(Math.max(0, Assiette), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
      <div className="payslip-column taux">
        {TauxSalariale === "" ? "" : applyFormat(Math.max(0, TauxSalariale), "ufloat", { thousands: " ", decimal: ",", unit: "%", precision: 3 })}
      </div>
      <div className="payslip-column cotisation">
        {applyFormat(Math.max(0, CotisationSalariale), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
      <div className="payslip-column taux">
        {TauxPatronale === "" ? "" : applyFormat(Math.max(0, TauxPatronale), "ufloat", { thousands: " ", decimal: ",", unit: "%", precision: 3 })}
      </div>
      <div className="payslip-column cotisation">
        {CotisationPatronale === "" ? "" : applyFormat(Math.max(0, CotisationPatronale), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
    </div>
  );
};

// Composant pour une carte de section
const SectionCard = ({ title, amount, icon = "📊", extraClass = "" }) => {
  return (
    <div className={`payslip-card payslip-section-card ${extraClass}`}>
      <div className="payslip-column libelle">
        <div className="payslip-icon">{icon}</div>
        {title}
      </div>
      <div className="payslip-column assiette"></div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation">
        {amount && applyFormat(Math.max(0, amount), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation"></div>
    </div>
  );
};

// Composant pour une carte de total
const TotalCard = ({ title, amountSalarie, amountPatronale, icon = "💰" }) => {
  return (
    <div className="payslip-card payslip-total-card">
      <div className="payslip-column libelle">
        <div className="payslip-icon">{icon}</div>
        {title}
      </div>
      <div className="payslip-column assiette"></div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation">
        {amountSalarie && applyFormat(Math.max(0, amountSalarie), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation">
        {amountPatronale && applyFormat(Math.max(0, amountPatronale), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
    </div>
  );
};

// Composant pour une carte spéciale (réintégration, CSG, etc.)
const SpecialCard = ({ title, amount, icon = "⚠️", cardClass = "payslip-special-card" }) => {
  return (
    <div className={`payslip-card ${cardClass}`}>
      <div className="payslip-column libelle">
        <div className="payslip-icon">{icon}</div>
        {title}
      </div>
      <div className="payslip-column assiette"></div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation">
        {amount && applyFormat(Math.max(0, amount), "uint", { thousands: " ", decimal: ",", unit: " €" })}
      </div>
      <div className="payslip-column taux"></div>
      <div className="payslip-column cotisation"></div>
    </div>
  );
};

// Composant pour l'en-tête des colonnes
const PayslipHeader = () => {
  return (
    <div className="payslip-header-standalone">
      <div className="payslip-column libelle">Libellé</div>
      <div className="payslip-column assiette">Assiette</div>
      <div className="payslip-column taux">Taux Salarié</div>
      <div className="payslip-column cotisation">Cotisation Salarié</div>
      <div className="payslip-column taux">Taux Employeur</div>
      <div className="payslip-column cotisation">Cotisation Employeur</div>
    </div>
  );
};

const DetailFicheDePaie = ({ DetailFicheDePaie }) => {
  if (DetailFicheDePaie === undefined) {
    return null;
  }

  return (
    <Column fill>
      <CardBox bpad>
        <Column fill>
          <div className="fiche-paie-container">
            {/* Section Salaire Brut */}
            <div className="payslip-card-list-container">
              <SectionCard 
                title="SALAIRE BRUT" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSalaireBrut}
                icon="💰"
              />
            </div>
            
            {/* Container pour les informations complémentaires */}
            <div className="payslip-info-container">
              <SpecialCard 
                title="Salaire de base" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSalaireBrut}
                icon="💼"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Article 82 / PER individuel" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.InfoCotisation82}
                icon="🔗"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Avantages en nature" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.InfoAvantageNature}
                icon="🎁"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Dépassement du disponible social 83" 
                amount={DetailFicheDePaie.TabRecap?.DepassementSocial83}
                icon="📈"
                cardClass="payslip-info-card"
              />
            </div>
            
            {/* Section Base Sociale */}
            <div className="payslip-card-list-container no-border">
              <SectionCard 
                title="BASE SOCIALE ANNUELLE" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                icon="🏛️"
                extraClass="base-sociale"
              />
            </div>
            
            {/* En-tête des colonnes pour les cotisations */}
            <PayslipHeader />
            
            <div className="payslip-card-list-container">
              {/* Cotisations Sociales */}
              <CotisationCard
                Libelle="Assurance maladie"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.assurance_maladie}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.AssuranceMaladieSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.assurance_maladie}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AssuranceMaladiePatronale}
                icon="🏥"
              />
              
              <CotisationCard
                Libelle="Allocations familiales"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.allocation_familiale}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AllocationFamilialePatronale}
                icon="👨‍👩‍👧‍👦"
              />
              
              <CotisationCard
                Libelle="Aide au logement"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteAideAuLogement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.aide_logement}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AideLogementTousPatronale}
                icon="🏠"
              />
              
              <CotisationCard
                Libelle="Assurance vieillesse - veuvage"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.assurance_vieillesse_veuvage}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.AssuranceVieillesseVeuvageSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.assurance_vieillesse_veuvage}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AssuranceVieillesseVeuvagePatronale}
                icon="👴"
              />
              
              <CotisationCard
                Libelle="Assurance vieillesse plafonnée"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassementMinPass}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.assurance_vieillesse_plafonnee}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.AssuranceVieillessePlafonneeSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.assurance_vieillesse_plafonnee}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AssuranceVieillessePlafonneePatronale}
                icon="🔒"
              />
              
              <CotisationCard
                Libelle="Accident du travail"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.accident_travail}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AccidentTravailPatronale}
                icon="⚠️"
              />
              
              <CotisationCard
                Libelle="Pénibilité de base"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.penibilite}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.PenibilitePatronale}
                icon="🛠️"
              />
              
              <CotisationCard
                Libelle="Construction"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.construction}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ConstructionPatronale}
                icon="🏗️"
              />
              
              <CotisationCard
                Libelle="Apprentissage"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.apprentissage}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ApprentissagePatronale}
                icon="🎓"
              />
              
              <CotisationCard
                Libelle="Formation"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.formation}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.FormationPatronale}
                icon="📚"
              />
              
              <CotisationCard
                Libelle="Transport"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.transport}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.TransportPatronale}
                icon="🚌"
              />
              
              <CotisationCard
                Libelle="Contribution syndicale"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteSbDepassement}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.contribution_syndicale}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ContributionSyndicalePatronale}
                icon="👥"
              />
              
              <CotisationCard
                Libelle="Forfait social prévoyance"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteForfaitSocialPrevoyance}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.forfait_social_prevoyance83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ForfaitSocialPrevoyance83Patronale}
                icon="🛡️"
              />
              
              <CotisationCard
                Libelle="Forfait social sur article 83 retraite"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteForfaitSocialRetraite}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.forfait_social_retraite83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ForfaitSocialRetraite83Patronale}
                icon="🔗"
              />
              
              <CotisationCard
                Libelle="Retraite AGIRC-ARRCO T1"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteAgircArrco}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.retraite_complementaire_agircarrco}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.RetraiteAgircArrcoSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.retraite_complementaire_agircarrco}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.RetraiteAgircArrcoPatronale}
                icon="🏦"
              />
              
              <CotisationCard
                Libelle="Retraite AGIRC-ARRCO T2"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteAgircArrcoT2}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.retraite_complementaire_agircarrcoT2}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.RetraiteAgircArrcoSalarialeT2}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.retraite_complementaire_agircarrcoT2}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.RetraiteAgircArrcoPatronaleT2}
                icon="🏦"
              />
              
              {/* Cotisations spéciales CAVEC */}
              {DetailFicheDePaie.TabCotisation?.CavecSalarieSalariale + DetailFicheDePaie.TabCotisation?.CavecSalariePatronale > 0 && (
                <SpecialCard 
                  title="Retraite complémentaire CAVEC" 
                  amount={DetailFicheDePaie.TabCotisation?.CavecSalarieSalariale + DetailFicheDePaie.TabCotisation?.CavecSalariePatronale}
                  icon="🏛️"
                  cardClass="payslip-special-card"
                />
              )}
              
              {/* Cotisations CNBF */}
              {DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseForfaitaireSalariale + DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseForfaitairePatronale > 0 && (
                <>
                  <SpecialCard 
                    title="Retraite de base forfaitaire CNBF" 
                    amount={DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseForfaitaireSalariale + DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseForfaitairePatronale}
                    icon="🏛️"
                    cardClass="payslip-special-card"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite de base proportionnelle CNBF"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteBaseProportionnelleSalarie}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteBaseProportionnelle}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseProportionnelleSalariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteBaseProportionnelle}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteBaseProportionnellePatronale}
                    icon="🏛️"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite complémentaire CNBF Tranche 1"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteComplementaire1}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteComplementaire1}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire1Salariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteComplementaire1}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire1Patronale}
                    icon="🏛️"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite complémentaire CNBF Tranche 2"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteComplementaire2}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteComplementaire2}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire2Salariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteComplementaire2}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire2Patronale}
                    icon="🏛️"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite complémentaire CNBF Tranche 3"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteComplementaire3}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteComplementaire3}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire3Salariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteComplementaire3}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire3Patronale}
                    icon="🏛️"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite complémentaire CNBF Tranche 4"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteComplementaire4}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteComplementaire4}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire4Salariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteComplementaire4}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire4Patronale}
                    icon="🏛️"
                  />
                  
                  <CotisationCard
                    Libelle="Retraite complémentaire CNBF Tranche 5"
                    Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCnbfRetraiteComplementaire5}
                    TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.CnbfRetraiteComplementaire5}
                    CotisationSalariale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire5Salariale}
                    TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.CnbfRetraiteComplementaire5}
                    CotisationPatronale={DetailFicheDePaie.TabCotisation?.CnbfRetraiteComplementaire5Patronale}
                    icon="🏛️"
                  />
                </>
              )}
              
              {/* Cotisations complémentaires */}
              <CotisationCard
                Libelle="APEC"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteApec}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.apec}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.ApecSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.apec}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ApecPatronale}
                icon="🔍"
              />
              
              <CotisationCard
                Libelle="CET"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCet}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.cet}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.CetSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.cet}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.CetPatronale}
                icon="⏰"
              />
              
              <CotisationCard
                Libelle="CEG T1"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteAgircArrco}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.ceg}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.CegSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.ceg}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.CegPatronale}
                icon="⚖️"
              />
              
              <CotisationCard
                Libelle="CEG T2"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteAgircArrcoT2}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.cegT2}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.CegSalarialeT2}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.cegT2}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.CegPatronaleT2}
                icon="⚖️"
              />
              
              <CotisationCard
                Libelle="Assurance chômage TA"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheA}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.assurance_chomageTA}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.ChomageTASalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.assurance_chomageTA}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ChomageTAPatronale}
                icon="💼"
              />
              
              <CotisationCard
                Libelle="Assurance chômage TB"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheB}
                TauxSalariale={DetailFicheDePaie.TabTauxSalariale?.assurance_chomageTB}
                CotisationSalariale={DetailFicheDePaie.TabCotisation?.ChomageTBSalariale}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.assurance_chomageTB}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.ChomageTBPatronale}
                icon="💼"
              />
              
              <CotisationCard
                Libelle="AGS"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteApec}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.ags}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.AgsPatronale}
                icon="🛡️"
              />
              
              {/* Cotisations Article 83 - Prévoyance */}
              <CotisationCard
                Libelle="Prévoyance complémentaire 83 TA"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheA83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheA_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheA_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheA_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheA_patronale83}
                icon="🛡️"
              />
              
              <CotisationCard
                Libelle="Prévoyance complémentaire 83 TB"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheB83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheB_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheB_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheB_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheB_patronale83}
                icon="🛡️"
              />
              
              <CotisationCard
                Libelle="Prévoyance complémentaire 83 TC"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheC83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheC_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheC_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheC_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheC_patronale83}
                icon="🛡️"
              />
              
              <CotisationCard
                Libelle="Prévoyance complémentaire 83 TD"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheD83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheD_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheD_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_prevoyance_trancheD_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.prevoyance_trancheD_patronale83}
                icon="🛡️"
              />
              
              {/* Frais de santé 83 */}
              <CotisationCard
                Libelle="Frais de santé 83"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteFraisSante}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_sante_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.sante_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_sante_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.sante_patronale83}
                icon="🏥"
              />
              
              {/* Retraite supplémentaire 83 */}
              <CotisationCard
                Libelle="Retraite supplémentaire 83 TA"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheA83Retraite}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheA_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.retraite_trancheA_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheA_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.retraite_trancheA_patronale83}
                icon="🏦"
              />
              
              <CotisationCard
                Libelle="Retraite supplémentaire 83 TB"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheB83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheB_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.retraite_trancheB_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheB_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.retraite_trancheB_patronale83}
                icon="🏦"
              />
              
              <CotisationCard
                Libelle="Retraite supplémentaire 83 TC"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheC83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheC_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.retraite_trancheC_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheC_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.retraite_trancheC_patronale83}
                icon="🏦"
              />
              
              <CotisationCard
                Libelle="Retraite supplémentaire 83 TD"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTrancheD83}
                TauxSalariale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheD_salarie83}
                CotisationSalariale={DetailFicheDePaie.TabCotisation83?.retraite_trancheD_salarie83}
                TauxPatronale={DetailFicheDePaie.TabTaux83?.taux_retraite_trancheD_patronale83}
                CotisationPatronale={DetailFicheDePaie.TabCotisation83?.retraite_trancheD_patronale83}
                icon="🏦"
              />
              
              {/* Taxes sur les salaires */}
              <CotisationCard
                Libelle="Taxe sur les salaires T1"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTaxeSalaireT1}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.taxe_salaireT1}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.TaxeSalaireT1Patronale}
                icon="💰"
              />
              
              <CotisationCard
                Libelle="Taxe sur les salaires T2"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTaxeSalaireT2}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.taxe_salaireT2}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.TaxeSalaireT2Patronale}
                icon="💰"
              />
              
              <CotisationCard
                Libelle="Taxe sur les salaires T3"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTaxeSalaireT3}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.taxe_salaireT3}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.TaxeSalaireT3Patronale}
                icon="💰"
              />
              
              <CotisationCard
                Libelle="Taxe sur les salaires T4"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteTaxeSalaireT4}
                TauxSalariale={0}
                CotisationSalariale={0}
                TauxPatronale={DetailFicheDePaie.TabTauxPatronale?.taxe_salaireT4}
                CotisationPatronale={DetailFicheDePaie.TabCotisation?.TaxeSalaireT4Patronale}
                icon="💰"
              />
              
              {/* Cotisations manuelles */}
              {DetailFicheDePaie.TabCotisationsSalarieManuelle?.map((CotisationManuelle, index) => (
                <CotisationCard
                  key={index}
                  Libelle={CotisationManuelle.Libelle}
                  Assiette={CotisationManuelle.Assiette}
                  TauxSalariale={CotisationManuelle.TauxSalariale}
                  CotisationSalariale={CotisationManuelle.CotisationSalariale}
                  TauxPatronale={CotisationManuelle.TauxPatronale}
                  CotisationPatronale={CotisationManuelle.CotisationPatronale}
                  icon="⚙️"
                />
              ))}
              
              {/* CSG déductible */}
              <CotisationCard
                Libelle="CSG déductible"
                Assiette={DetailFicheDePaie.AssietteFicheDePaie?.AssietteCsg}
                TauxSalariale={DetailFicheDePaie.TabRecap?.TauxCsgDeductible}
                CotisationSalariale={DetailFicheDePaie.TabRecap?.CsgDeductible}
                TauxPatronale=""
                CotisationPatronale=""
                icon="🏛️"
              />
              
              {/* Total charges déductibles */}
              <TotalCard
                title="Total charges déductibles"
                amountSalarie={DetailFicheDePaie.TabRecap?.TotalChargeDeductible}
                amountPatronale={DetailFicheDePaie.TabRecap?.ChargesPatronaleSansReduction}
                icon="📊"
              />
              
              {/* CSG-CRDS non déductible */}
              <SpecialCard
                title="CSG-CRDS non déductible"
                amount={DetailFicheDePaie.TabRecap?.CsgNonDeductible}
                icon="🏛️"
                cardClass="payslip-special-card"
              />
              
              {/* CSG-CRDS non déductible sur épargne investie */}
              {DetailFicheDePaie.TabCotisation?.CsgESPrimes !== 0 && (
                <SpecialCard
                  title="CSG-CRDS non déductible sur épargne investie"
                  amount={DetailFicheDePaie.TabCotisation?.CsgESPrimes}
                  icon="💰"
                  cardClass="payslip-special-card"
                />
              )}
              
              {/* Réduction générale */}
              {DetailFicheDePaie.TabRecap?.ReductionGenerale !== 0 && (
                <SpecialCard
                  title="Réduction générale"
                  amount={-DetailFicheDePaie.TabRecap?.ReductionGenerale}
                  icon="📉"
                  cardClass="payslip-reduction-card"
                />
              )}
              
            </div>
            
            {/* Section Salaire Net à Payer */}
            <div className="payslip-card-list-container">
              <SectionCard 
                title="SALAIRE NET A PAYER" 
                amount={DetailFicheDePaie.TabRecap?.RecapSalaireNet}
                icon="💰"
              />
            </div>
            
            {/* Container pour les informations fiscales */}
            <div className="payslip-info-container">
              <SpecialCard 
                title="Salaire imposable avant dépassement" 
                amount={DetailFicheDePaie.TabRecap?.SalaireImposableAvantDepassement}
                icon="📋"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Réintégration article 82 / PER individuel" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.InfoCotisation82}
                icon="🔗"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Réintégration avantages en nature" 
                amount={DetailFicheDePaie.AssietteFicheDePaie?.InfoAvantageNature}
                icon="🎁"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Part patronale de la complémentaire santé" 
                amount={DetailFicheDePaie.TabRecap?.RecapSantePatronale}
                icon="🏥"
                cardClass="payslip-info-card"
              />
              
              <SpecialCard 
                title="Dépassement du disponible fiscal 83" 
                amount={DetailFicheDePaie.TabRecap?.DepassementFiscal83}
                icon="📈"
                cardClass="payslip-info-card"
              />
            </div>
            
            {/* Section Salaire Net Fiscal */}
            <div className="payslip-card-list-container no-border">
              <SectionCard 
                title="SALAIRE NET FISCAL" 
                amount={DetailFicheDePaie.TabRecap?.SalaireNetFiscale}
                icon="🏛️"
                extraClass="net-fiscal"
              />
            </div>
          </div>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailFicheDePaie;
